import { observable, action } from 'mobx'

export default class QuestionChallenge {
  @observable answer = ''

  constructor ({ challenge }) {
    Object.assign(this, challenge)
  }

  @action setAnswer (answer) {
    this.answer = answer
  }
}



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/MultiFactorAuth/QuestionChallenge/Challenge.js